import React, { useEffect } from 'react';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { compose } from 'recompose';
import molecules from 'ctsutheme/components/molecules';
import { connect } from 'react-redux';
import { getProtocolDetails } from 'actions/protocols/protocoldetail';
import { bindActionCreators } from 'redux';
import { withAppContext } from '@ctsu/loader';
import { bindLogger } from 'helpers/BindLogger';
import atoms from 'ctsutheme/components/atoms';
import { StickyHeader } from 'components/Layout/Header';
import { lSelectorGetProtDetails, eSelectorGetProtDetails } from 'selectors';
import { RenderControl, RenderElement } from 'components/RenderHelpers';
import { CanUserAccessInfo } from 'appconstants/Permission';
import { BoolToString, ProtocolIButton } from 'components';

const { Typography } = atoms;
const { Card, CardContent } = molecules;

const styles = theme => ({
  infoBtn: {
    padding: '0px'
  },
  headerCardContent: {
    padding: '.5rem 1rem !important',
    textAlign: 'center'
  },
  cardRoot: {
    minHeight: '85vh',
    margin: '5px'
  },
  headerCard: {
    borderRadius: 25,
    margin: '.5rem !important'
  },
  sessionInfoContainer: {
    textAlign: 'center'
  },
  headerStickyContent: {
    textAlign: 'center'
  }
});

const HeaderContent = ({
  protocolNumber,
  handleIButtonClick,
  leadGrp,
  phase,
  isIrbExempt,
  grpProtStatus,
  grpProtStatusDate,
  nihAdminCode,
  isCirbRequired,
  isSticky
}) => (
  <>
    &nbsp;
    Protocol:
    {!isSticky && <span style={{ marginTop: '-.15rem' }} ><ProtocolIButton protocolNumber={protocolNumber} /></span>}
    <span className={`font-semibold ${!isSticky ? 'ml-n1' : 'ml-1'} mr-3`}>{protocolNumber}</span>
    Lead Group:
    <span className="font-semibold ml-1 mr-3">{leadGrp}</span>
    Phase:
    <span className="font-semibold ml-1 mr-3">{phase}</span>
    Group Protocol Status:
    <span className="font-semibold ml-1 mr-3">
      {`${grpProtStatus} (${grpProtStatusDate && grpProtStatusDate.split(' ')[0]})`}
    </span>
    {
      isIrbExempt
      ? 
      (<>
        IRB Exempt:
        <span className="font-semibold ml-1">
          <BoolToString boolValue={isIrbExempt} />
        </span> 
      </>)
      :
      (<>
        NIH Admin Code:
        <span className="font-semibold ml-1 mr-3">{nihAdminCode}</span>
        CIRB Reviewed?:
        <span className="font-semibold ml-1">
          <BoolToString boolValue={isCirbRequired} />
        </span> 
      </>)
    }
  </>
);


const PrtHeader = props => {
  const {
    classes,
    prtInfo,
    context,
    onGetPrtDetails,
    isSticky,
    isLoadingPrtDetails,
    iserrorPrtDetails,
    handleIButtonClick,
    id
  } = props;

  // const selProtocol = id;

  useEffect(() => {
    if (!_.isEmpty(id)) {
      bindLogger(onGetPrtDetails, context)(id);
    }
  }, [id, onGetPrtDetails, context]);

  if (!id) return null;

  return (
    <RenderControl
      isLoading={isLoadingPrtDetails}
      iserror={iserrorPrtDetails}
      compName="Protocol Header Information"
      permission={CanUserAccessInfo()}
    >
      <RenderElement access={isSticky}>
        <StickyHeader>
          <Typography variant="body2" align="center" component="div">
            <HeaderContent
              {...prtInfo}
              isSticky={isSticky}
              handleIButtonClick={handleIButtonClick}
            />
          </Typography>
        </StickyHeader>
      </RenderElement>
      <RenderElement access={!isSticky}>
        <Grid direction="row" justify="center" container>
          <Grid item>
            <Card className={`${classes.headerCard} sticky-margin`} elevation={1}>
              <CardContent className={classes.headerCardContent}>
                <Grid container style={{ alignItems: 'center' }}>
                  <HeaderContent
                    {...prtInfo}
                    isSticky={isSticky}
                    handleIButtonClick={handleIButtonClick}
                  />
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </RenderElement>
    </RenderControl>
  );
};

const withProtocolInfoState = connect(
  (state, ownProps) => ({
    prtInfo: state.prtDetails.prtInfo,
    isLoadingPrtDetails: lSelectorGetProtDetails(state),
    iserrorPrtDetails: eSelectorGetProtDetails(state)
  }),
  dispatch => bindActionCreators(
    {
      onGetPrtDetails: getProtocolDetails
    },
    dispatch
  )
);

const ProtocolHeader = withStyles(styles)(
  compose(
    withProtocolInfoState,
    withAppContext
  )(PrtHeader)
);

export { ProtocolHeader };
